import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function CrmLogin() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(email.trim().toLowerCase(), password);
            toast.success("Bienvenido");
            navigate("/crm");
        } catch (err) {
            toast.error(formatApiError(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-carbon px-6 py-12">
            <div className="w-full max-w-md">
                <div className="text-center mb-12">
                    <span className="font-heading text-4xl tracking-[0.25em] text-dorado">
                        TENERÍA
                    </span>
                    <p className="font-body uppercase tracking-[0.3em] text-xs text-piedra mt-3">
                        Panel de gestión
                    </p>
                    <div className="line-gold mx-auto mt-6" />
                </div>

                <form
                    onSubmit={onSubmit}
                    className="space-y-8 bg-carbon-suave/40 border border-dorado/20 p-10"
                    data-testid="login-form"
                >
                    <div>
                        <label className="line-label">Email</label>
                        <input
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="input-line"
                            data-testid="login-email"
                            autoComplete="email"
                        />
                    </div>
                    <div>
                        <label className="line-label">Contraseña</label>
                        <input
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="input-line"
                            data-testid="login-password"
                            autoComplete="current-password"
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={loading}
                        className="btn-gold-solid w-full disabled:opacity-50"
                        data-testid="login-submit"
                    >
                        {loading ? "Entrando..." : "Entrar"}
                    </button>
                </form>

                <p className="text-center mt-10">
                    <a href="/" className="font-body text-xs uppercase tracking-[0.25em] text-piedra hover:text-dorado">
                        ← Volver a la web
                    </a>
                </p>
            </div>
        </div>
    );
}
